
import {smartCreateContext} from './ContextHelpers';
import { logger } from '../helpers/LoggerHelper';

export interface IApplicationContext {
    SilentLoginWasSuccess: boolean;
    SilentLoginHasFinished: boolean;
    UserSkypeToken: string | null;
    LatestJoinLink: string;
    ApplicationIsBeingPrepared: boolean;
    LinkWasCopiedToClipboard: boolean;
}

export interface ApplicationAction {
  Action: ApplicationActionType;
  Payload?: any;
}

export enum ApplicationActionType {
    SilentLoginStarted,
    SilentLoginFinished,
    JoinLinkCreationStarted,
    JoinLinkCreationFinished,
    LinkWasCopiedToClipboard
}

const applicationContextInitialValue: IApplicationContext = {
    ApplicationIsBeingPrepared: true,
    LatestJoinLink: "",
    LinkWasCopiedToClipboard: false,
    SilentLoginHasFinished: false,
    SilentLoginWasSuccess: false,
    UserSkypeToken: null
};

function reducer(state: IApplicationContext, action: ApplicationAction): IApplicationContext {
  switch (action.Action) {
    case ApplicationActionType.SilentLoginStarted:
      logger.Log('reducer: SilentLoginStarted');
      return {
        ApplicationIsBeingPrepared: true,
        LatestJoinLink: "",
        LinkWasCopiedToClipboard: false,
        SilentLoginHasFinished: false,
        SilentLoginWasSuccess: false,
        UserSkypeToken: null
      };
      case ApplicationActionType.SilentLoginFinished:
          logger.Log('reducer: SilentLoginFinished');
          return {
          ApplicationIsBeingPrepared: false,
          LatestJoinLink: "",
          LinkWasCopiedToClipboard: false,
          SilentLoginHasFinished: true,
          SilentLoginWasSuccess: true,
          UserSkypeToken: action.Payload
        };
        case ApplicationActionType.JoinLinkCreationStarted:
            logger.Log('reducer: JoinLinkCreationStarted');
            return {
            ApplicationIsBeingPrepared: false,
            SilentLoginHasFinished: state.SilentLoginHasFinished,
            SilentLoginWasSuccess: state.SilentLoginWasSuccess,
            UserSkypeToken: state.UserSkypeToken,
            LinkWasCopiedToClipboard: false,
            LatestJoinLink : state.LatestJoinLink
          };
          case ApplicationActionType.JoinLinkCreationFinished:
              logger.Log('reducer: JoinLinkCreationFinished');
              return {
              ApplicationIsBeingPrepared: false,
              LatestJoinLink: action.Payload,
              LinkWasCopiedToClipboard: false,
              SilentLoginHasFinished: state.SilentLoginHasFinished,
              SilentLoginWasSuccess: state.SilentLoginWasSuccess,
              UserSkypeToken: state.UserSkypeToken
            };
            case ApplicationActionType.LinkWasCopiedToClipboard:
              logger.Log('reducer: LinkWasCopiedToClipboard');
              return {
              ApplicationIsBeingPrepared: false,
              LatestJoinLink: state.LatestJoinLink,
              LinkWasCopiedToClipboard: action.Payload,
              SilentLoginHasFinished: state.SilentLoginHasFinished,
              SilentLoginWasSuccess: state.SilentLoginWasSuccess,
              UserSkypeToken: state.UserSkypeToken
            };            
            
    default:
      throw new Error("Unsupported ApplicationActionType: " + action)
  }
}
logger.Log('creating context');
const [ctx, Provider] = smartCreateContext(reducer, applicationContextInitialValue)
export const ApplicationContext = ctx;
export const ApplicationContextProvider = Provider;
logger.Log('created context ');

